var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/sliders"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 18c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3z",
    className: "secondarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12c-.85 0-1.5.65-1.5 1.5s.65 1.5 1.5 1.5 1.5-.65 1.5-1.5-.65-1.5-1.5-1.5zm-9-5C8.65 7 8 7.65 8 8.5S8.65 10 9.5 10 11 9.35 11 8.5 10.35 7 9.5 7z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15a2.5 2.5 0 0 1 2.45 2h5.55a.5.5 0 1 1 0 1h-5.55a2.5 2.5 0 0 1-4.9 0H4.5a.5.5 0 1 1 0-1h4.55a2.5 2.5 0 0 1 2.45-2zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm6-6a2.5 2.5 0 1 1-2.45 3H4.5a.5.5 0 1 1 0-1h10.55a2.5 2.5 0 0 1 2.45-2zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-9-6a2.5 2.5 0 0 1 2.45 2h8.55a.5.5 0 1 1 0 1h-8.55a2.5 2.5 0 0 1-4.9 0H4.5a.5.5 0 0 1 0-1h1.55A2.5 2.5 0 0 1 8.5 5zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/sliders.229737f3179b4b87b005de28a80479d7.svg";
export { ForwardRef as ReactComponent };